/**
 * main.ts
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

// Plugins
import { registerPlugins } from '@/plugins'

// Styles
import '@/styles/main.scss'

// Components
import App from './App.vue'

// font
import 'unfonts.css'

// Composables
import { createApp } from 'vue'

import bootstrap from '@/bootstrap.ts'

const app = createApp(App)

registerPlugins(app)

bootstrap()

app.mount('#app')
